import { useAuth } from '../contexts/AuthContext';

/**
 * Hook pour vérifier les permissions basées sur le rôle d'organisation
 *
 * @returns {Object} Permissions pour l'utilisateur actuel
 */
export const usePermissions = () => {
    const { user } = useAuth();

    // Rôle d'organisation de l'utilisateur
    const organizationRole = user?.organization_role || null;

    // Définition des permissions par rôle
    const permissions = {
        owner: {
            canRead: true,
            canCreate: true,
            canUpdate: true,
            canDelete: true,
            canManage: true,
        },
        admin: {
            canRead: true,
            canCreate: true,
            canUpdate: true,
            canDelete: true,
            canManage: true,
        },
        editor: {
            canRead: true,
            canCreate: true,
            canUpdate: true,
            canDelete: true,
            canManage: false,
        },
        viewer: {
            canRead: true,
            canCreate: false,
            canUpdate: false,
            canDelete: false,
            canManage: false,
        },
    };

    // Retourner les permissions pour le rôle actuel (ou viewer par défaut)
    const rolePermissions = permissions[organizationRole] || permissions.viewer;

    return {
        ...rolePermissions,
        organizationRole,
        isOwner: organizationRole === 'owner',
        isAdmin: organizationRole === 'admin',
        isEditor: organizationRole === 'editor',
        isViewer: organizationRole === 'viewer',
    };
};
